import { UUID } from '@okcargo-apps/shared-domain';

export interface IAccount {
  capabilities: ECapabilities[]; // NEW
  role: ERoles; // NEW
  lang: string;

  id: string; // is the same as contactId
  firstName: string;
  lastName: string;
  email: string;
  username: string;
  privacyPolicyAccepted?: boolean;
  // activated?: boolean,
  company: ICompany; // from /services/uaa/api/carriers/mine (company object)

  contactId: UUID;
  phone?: string;
}
export interface ICompany {
  id?: UUID;
  name: string;
  taxNumber: string;
  streetAddress: string;
  postalCode: string;
  city: string;
  // stateProvince: string;
  // country: string;
  phone: string;
  activated: boolean;
  isInternational: boolean;
  // isFreelance: boolean; // from root json (outside company object); not in use
  isMarketAllowed: boolean;
  costCenters?: ICostCenter[];

  decaCredits?: number;
  stateCode: string;
  countryCode: string;
}

export interface ICostCenter {
  id: UUID;
  name: string;
  // the following, are these necessary?
  // companyId?: number;
  // streetAddress?: string;
  // postalCode?: string;
  // city?: string;
  // stateProvince?: string;
  // country?: string;
}

export function getEmptyIAccount(): IAccount {
  return {
    id: '',

    capabilities: [] as const, // NEW
    role: ERoles.DEFAULT, // NEW
    lang: 'es',

    contactId: '',

    firstName: '',
    lastName: '',
    email: '',
    username: '',
    company: {
      // id: undefined,
      name: '',
      taxNumber: '',
      streetAddress: '',
      postalCode: '',
      city: '',
      stateCode: '',
      countryCode: '',
      phone: '',
      activated: false,
      isInternational: false,
      // isFreelance: false,
      isMarketAllowed: true,
    },
  };
}

export enum ERoles {
  DEFAULT = 'DEFAULT',
  DRIVER = 'DRIVER',
  ADMINISTRATIVE = 'ADMINISTRATIVE',
  DRIVER_ADMINISTRATIVE = 'DRIVER_ADMINISTRATIVE',
}

export enum ECapabilities {
  AUTHENTICATED = 'AUTHENTICATED',
  INTERACT_WITH_STOPS = 'INTERACT_WITH_STOPS',
  ADMINISTRATIVE_DOCUMENTS = 'ADMINISTRATIVE_DOCUMENTS',
  VIEW_PRICES = 'VIEW_PRICES',
  VIEW_MARKET = 'VIEW_MARKET',
  VIEW_DRIVERS = 'VIEW_DRIVERS',
  UPLOAD_FREIGHTS = 'UPLOAD_FREIGHTS',
  CRUD_VEHICLES = 'CRUD_VEHICLES', //
  CRUD_USERS_CARRIER = 'CRUD_USERS_CARRIER',
  CRUD_USERS_SHIPPER = 'CRUD_USERS_SHIPPER',
  CRUD_USERS_DECA_CARRIER = 'CRUD_USERS_DECA_CARRIER',
  CRUD_USERS_DECA_SHIPPER = 'CRUD_USERS_DECA_SHIPPER',
  VIEW_MILEAGES = 'VIEW_MILEAGES',
  ASSIGN_DRIVERS = 'ASSIGN_DRIVERS',
  SUSTAINABILITY = 'SUSTAINABILITY',

  CREATE_DECA_AS_SHIPPER = 'CREATE_DECA_AS_SHIPPER',
  CREATE_DECA_AS_CARRIER = 'CREATE_DECA_AS_CARRIER',

  MODIFY_DECA_GOODS_DATA = 'MODIFY_DECA_GOODS_DATA',
  MODIFY_DECA_LOCATIONS = 'MODIFY_DECA_LOCATIONS',
  MODIFY_DECA_DATES = 'MODIFY_DECA_DATES',
  MODIFY_DECA_VEHICLES = 'MODIFY_DECA_VEHICLES',
  MODIFY_DECA_RESERVATIONS = 'MODIFY_DECA_RESERVATIONS',

  VIEW_DECA_AS_SHIPPER = 'VIEW_DECA_AS_SHIPPER',
  VIEW_DECA_AS_CARRIER = 'VIEW_DECA_AS_CARRIER',
  VIEW_DECA_AS_DRIVER = 'VIEW_DECA_AS_DRIVER',
}

/** Capabilities that grant access to the users management screen. */
export const CRUD_USERS_CAPABILITIES: readonly ECapabilities[] = [
  ECapabilities.CRUD_USERS_CARRIER,
  ECapabilities.CRUD_USERS_SHIPPER,
  ECapabilities.CRUD_USERS_DECA_CARRIER,
  ECapabilities.CRUD_USERS_DECA_SHIPPER,
];
